export default {
  title: "Block",
  title_3d: "3D viwe",
  title_video: "Video",
  data_specs: {
    title: "Data",
    list: [
      {
        entity: "type",
        label: "Type",
        unit: "",
        unit_small: "",
      },
      {
        entity: "width",
        label: "Width",
        unit: "meters",
        unit_small: "m",
      },
      {
        entity: "height",
        label: "Heigth",
        unit: "meters",
        unit_small: "m",
      },
      {
        entity: "diameter",
        label: "Length",
        unit: "meters",
        unit_small: "m",
      },
      {
        entity: "weight",
        label: "Weight",
        unit: "Tons",
        unit_small: "Ton",
      },
    ],
  },

  data_media: {
    title: 'Media',
    list: [
      {
        entity: "total_images",
        label: "Photos for website",
      },
      {
        entity: "length_img_3d",
        label: "Photos for 3D",
      },
      {
        entity: "video_label",
        label: "Video",
      },
    ],
  },

  data_3d: {
    title: '3D',
    list: [
      {
        entity: "total_files",
        label: "Total files",
      },
      {
        entity: "model",
        label: "Path",
      },
      {
        entity: "label_obj",
        label: "Obj file",
      },
      {
        entity: "label_created",
        label: "Created at",
      },
    ],
  },
};
